import React, { createContext } from "react"

// The page language comes from pageContext (set in gatsby-node.js), so it is
// known during SSR. Pages not created there (e.g. 404) fall back to the URL.
export const PageLanguageContext = createContext(undefined)

const languageOf = ({ pageContext, location }) =>
  pageContext?.language ??
  (location?.pathname?.startsWith("/pl/") ? "pl" : "en")

export const wrapPageElement = ({ element, props }) => (
  <PageLanguageContext.Provider value={languageOf(props)}>
    {element}
  </PageLanguageContext.Provider>
)
